import React from 'react'
import { StyledFlexRow, StyledWebLink } from './OlympicWidgetLinks.styled'

export interface OlympicWidgetLinksProps {
    isFullSize: boolean
    pageType: string
}

export function OlympicWidgetLinks(props: OlympicWidgetLinksProps) {
    const { isFullSize, pageType } = props

    return (
        <StyledFlexRow isFullSize={isFullSize}>
            <StyledWebLink
                to="/sport/olympics/medal-tally"
                className={pageType === 'medal-tally' ? 'isActive' : undefined}
            >
                Medal Tally
            </StyledWebLink>
            <StyledWebLink
                to="/sport/olympics/schedule"
                className={pageType === 'schedule' ? 'isActive' : undefined}
            >
                Schedule
            </StyledWebLink>
            <StyledWebLink
                to="/sport/olympics/results"
                className={pageType === 'results' ? 'isActive' : undefined}
            >
                Results
            </StyledWebLink>
        </StyledFlexRow>
    )
}
